import React from 'react';

// 💳 10-29 the LASTING Chip in thank-you in the MAIN chat (utils/chipIn.chipInThanksView, place
// 'feed'): rooms with no ghost chat (ported 1:1 rooms, the quiet room presets). A centered,
// page-only line at the time the thank-you went out; nothing here is a chat message, so no AI
// reads it. Armor: generated room themes style any class holding card/panel/chip/message/…, so
// this wears no class at all; its look is inline. It inherits the feed's text color (light and
// dark themes) and takes a soft gold pill.
export default function ChipInLine({ data }) {
  const text = data && typeof data.text === 'string' ? data.text : '';
  if (!text) return null;
  const speaker = data && typeof data.speaker === 'string' && data.speaker ? data.speaker : null;
  return (
    <div
      role="note"
      data-chip-in-line={data.mine ? 'mine' : '1'}
      style={{ display: 'flex', justifyContent: 'center', margin: '10px 0', padding: '0 8px', boxSizing: 'border-box' }}
    >
      <span
        style={{
          boxSizing: 'border-box',
          maxWidth: '100%',
          padding: '6px 14px',
          borderRadius: 999,
          border: '1px solid rgba(240,201,106,0.45)',
          background: 'rgba(240,201,106,0.12)',
          color: 'inherit',
          fontSize: '0.85em',
          lineHeight: 1.4,
          textAlign: 'center',
          overflowWrap: 'anywhere',
        }}
      >
        {speaker ? <strong style={{ fontWeight: 700 }}>{speaker}: </strong> : null}
        {text}
      </span>
    </div>
  );
}
